export default __webpack_public_path__ + "static/media/logo-wanderruf.8324143b.svg";